module.exports = __webpack_public_path__ + "img/14.59fc21a0.webp";